import { useContext } from "react";
import { Link } from "react-router-dom";
import { contextTheme } from "../contexts/ProviderTheme";
import { contextWeb3 } from "../contexts/ProviderWeb3";

export default function Title() {
  const { theme } = useContext(contextTheme);
  const { msgNet } = useContext(contextWeb3);

  const style = {
    color: !theme ? "#333" : "#FFF",
  };
  return (
    <div className="title">
      <h1>
        <Link style={style} to="/">
          E-commerce Crypto
        </Link>
      </h1>

      {msgNet !== "" ? (
        <div
          style={{
            padding: "10px",
            width: "100%",
            backgroundColor: "#faff9a",
            color: "#222",
            fontSize: "14px",
            textTransform: "none",
          }}
        >
          {msgNet}
        </div>
      ) : null}
    </div>
  );
}
